import { TextStyle } from 'react-native';
import RegularText from "./RegularText";


export class SemiBoldText extends RegularText {
    addStyles: (() => TextStyle) = () => ({ fontFamily: 'NunitoSemiBold' });
}

export default SemiBoldText;